const MINIMUM_ETA_WINDOW_MS = 10000
const SECONDS_PER_MINUTE = 60
const SECONDS_PER_HOUR = 3600

export function getElapsedTime(startedAt) {
    const elapsedMs = getElapsedMs(startedAt)
    if (elapsedMs == null) {
        return "0s"
    }

    return formatElapsedSeconds(Math.floor(elapsedMs / 1000))
}

export function getEstimatedTime({ startedAt, total = 0, remaining = 0 }) {
    const elapsedMs = getElapsedMs(startedAt)
    const processed = total - remaining
    if (elapsedMs == null || processed <= 0) {
        return null
    }

    if (elapsedMs < MINIMUM_ETA_WINDOW_MS) {
        return null
    }

    const ratePerSecond = processed / (elapsedMs / 1000)
    if (ratePerSecond <= 0) {
        return null
    }

    return formatEstimatedRemainingSeconds(Math.ceil(remaining / ratePerSecond))
}

export function getProcessedText({ total = 0, remaining = 0 }) {
    if (!total) {
        return null
    }

    const processed = total - remaining
    return `${processed.toLocaleString()} of ${total.toLocaleString()} assets processed`
}

function getElapsedMs(startedAt) {
    if (!isValidStartTime(startedAt)) {
        return null
    }

    return Math.max(0, Date.now() - startedAt)
}

function formatElapsedSeconds(totalSeconds) {
    if (totalSeconds < SECONDS_PER_MINUTE) {
        return `${totalSeconds}s`
    }

    if (totalSeconds < SECONDS_PER_HOUR) {
        const mins = Math.floor(totalSeconds / SECONDS_PER_MINUTE)
        const secs = totalSeconds % SECONDS_PER_MINUTE
        return `${mins}m ${secs}s`
    }

    const hours = Math.floor(totalSeconds / SECONDS_PER_HOUR)
    const mins = Math.floor((totalSeconds % SECONDS_PER_HOUR) / SECONDS_PER_MINUTE)
    return `${hours}h ${mins}m`
}

function formatEstimatedRemainingSeconds(remainingSeconds) {
    if (remainingSeconds < SECONDS_PER_MINUTE) {
        return "<1min"
    }

    if (remainingSeconds < SECONDS_PER_HOUR) {
        return `${Math.ceil(remainingSeconds / SECONDS_PER_MINUTE)}min`
    }

    const hours = Math.floor(remainingSeconds / SECONDS_PER_HOUR)
    const mins = Math.ceil((remainingSeconds % SECONDS_PER_HOUR) / SECONDS_PER_MINUTE)
    return `${hours}h ${mins}m`
}

function isValidStartTime(startedAt) {
    return Number.isFinite(startedAt) && startedAt > 0
}
